import React from 'react';
import {Address} from 'presentation/components/ChangeData/Address';
import {useChangeDataProfile} from 'presentation/pages/private/hooks';
import {AccordionStateEnum} from '../../store/formAccordionStore/types';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {FeaturesEnum} from 'presentation/constants';
import {usePersonalData} from 'presentation/hooks';
import {useChangeDataAlertStore} from '../../store/changeDataAlertStore';
import {EmptyAlertEnum} from 'presentation/components/ChangeData/EmptyAlert/constants';
import {Stack} from '@mui/material';
import {AlertInfo} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {MyProfileEnum} from 'main/analytics/gaTagsEnum';
import {AddressDataFormValues} from 'presentation/components/ChangeData/Address/AddressForm/validation';
import {formatMasks, getAddressByGroups} from 'presentation/utils';
import {PostChangeAddressRequest} from 'domain/usecases';
const {changeData} = translations['pt-br'].privateFlow.profile;

export function AddressField() {
	const {
		changeDataFormState,
		handleChangeDataFocus,
		changeAddressIsLoading,
		onCancel,
		handleChangeAddress,
	} = useChangeDataProfile();

	const {isEnabled: isNewProfileFeatureFlagEnabled} = useFeatureFlag(
		FeaturesEnum.ADD__PORTAL_FEATURE_NEW_PROFILE,
	);

	const {userLocation, emptyLocation, accountData} = usePersonalData();
	const changeDataAlertState = useChangeDataAlertStore(state => state.status);

	const showForm =
		changeDataFormState.name === AccordionStateEnum.ADDRESS && changeDataFormState.isFormActive;

	const onSubmit = async (data: AddressDataFormValues) => {
		const mappedAddress = getAddressByGroups(data.address);

		const parsedData: PostChangeAddressRequest = {
			cdUsuario: accountData.beneficiary.cdUsuarioC.trim(),
			nmUf: data.state.toUpperCase().trim(),
			nmCidade: data.city.toUpperCase().trim(),
			nmBairro: data.district.toUpperCase().trim(),
			nmTipoLogradouro: mappedAddress.addressType.toUpperCase().trim(),
			nmRua: mappedAddress.addressName.toUpperCase().trim(),
			nuEndereco: data.withoutNumber ? '' : data.number.trim(),
			dsComplemento: data.complement.toUpperCase().trim(),
			nuCep: formatMasks('clear', data.zipCode),
			flTipoEndereco: '1',
			favoriteAddress: data?.favoriteAddress?.trim(),
		};
		handleChangeAddress(parsedData);
	};

	if (isNewProfileFeatureFlagEnabled) {
		return (
			<Address.Form
				onCancel={() => onCancel(AccordionStateEnum.ADDRESS)}
				onSave={onSubmit}
				loading={changeAddressIsLoading}
			/>
		);
	}

	if (emptyLocation && !showForm) {
		return (
			<Address.Empty
				type={EmptyAlertEnum.ADDRESS}
				onClick={() => handleChangeDataFocus(AccordionStateEnum.ADDRESS, true)}
				dataTagId={MyProfileEnum.CLICK_CADASTRAR_ENDERECO}
			/>
		);
	}

	if (showForm) {
		return (
			<Stack>
				<AlertInfo.Root sx={{mt: -1, mb: 2}}>
					<AlertInfo.Description>{changeData.alertInfo}</AlertInfo.Description>
				</AlertInfo.Root>
				<Address.Form
					onCancel={() => onCancel(AccordionStateEnum.ADDRESS)}
					onSave={onSubmit}
					loading={changeAddressIsLoading}
				/>
			</Stack>
		);
	}

	if (userLocation) {
		return (
			<Stack>
				<AlertInfo.Root sx={{mt: -1, mb: 2}}>
					<AlertInfo.Description>{changeData.alertInfo}</AlertInfo.Description>
				</AlertInfo.Root>
				<Address.Data
					addressData={userLocation}
					onOpenForm={() => handleChangeDataFocus(AccordionStateEnum.ADDRESS, true)}
					status={changeDataAlertState}
				/>
			</Stack>
		);
	}
}
